"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListAutoTestSnapshots = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListAutoTestSnapshotsCommand_1 = require("../commands/ListAutoTestSnapshotsCommand");
const core_1 = require("@smithy/core");
exports.paginateListAutoTestSnapshots = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListAutoTestSnapshotsCommand_1.ListAutoTestSnapshotsCommand, "nextToken", "nextToken", "pageSize");
